<template>
  <div class="col-12 card p-0 fs-5">
    <div class="card-header  fw-bold pt-2 pb-0 pl-3 pr-0">
      <p class="m-0">Add Charge</p>
    </div>
    <div class="card-body p-3 m-0">
      <p class="fs-5" v-if="helpText" v-html="helpText"></p>
      <p class="fs-5 fw-bold">Add the following charge?</p>
      <p class="fs-5">
        {{ chargeToAdd.codeDefinitionCode }} {{ chargeToAdd.statuteDefinitionSection }} as
        Count {{ countNumber }}
        <span v-if="chargeToEnhance"
          >(attached to {{ chargeToEnhance.codeDefinitionCode }}
          {{ chargeToEnhance.statuteDefinitionSection }})</span
        >
      </p>
      <button class="btn btn-primary btn-xl" @click="addCharge">Add</button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["chargeToAdd", "countNumber", "chargeToEnhance", "helpText", "caseId"],
  methods: {
    addCharge() {
      // console.log(
      //   "DATES: ",
      //   this.chargeToEnhance.Date,
      //   this.chargeToEnhance.DateRangeEnd
      // );
      this.$emit("addChargeFromPopup", {
        currentCount: this.countNumber,
        crimeId: this.chargeToAdd.Id,
        CrimeState: "Completed",
        OffenseDate: this.chargeToEnhance.Date,
        DateRangeEnd: this.chargeToEnhance.DateRangeEnd,
      });
    },
  },
  mounted(){
    
  },
};
</script>
